/**
 * SOLID Review
 * S — Strong. Sole job: lazily construct a real LiveKitClientAdapter.
 * O — N/A — nothing to extend; a single factory.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. Implements the single-method IServiceLiveKitAdapter port.
 * D — Strong. Depends on its own sibling LiveKitClientAdapter via a dynamic import (not a static one) so
 *     the livekit-client SDK chunk stays out of the main bundle until a LiveKit connection is actually
 *     requested — matches the lazy-load behavior AppRoot.tsx used to do inline before Part 6d. The logger
 *     and the timers it hands each adapter are the platform's (frontend-infrastructure-oo P3, P4).
 */
import type { IServiceLiveKitAdapter, IGatewayLiveKit } from '../../application/ports/IGatewayLiveKit';
import type { IServiceLogger } from '../platform/IServiceLogger';
import type { IServiceTimers } from '../platform/IServiceTimers';

/**
 * THE LIVEKIT CLIENT FACTORY (frontend-infrastructure-oo P3, 2026-10-29, §28.288): a class since the adapter is handed the
 * platform's logger and, since P4, its timers — it was a module object, `liveKitClientAdapterFactory`, building the adapter over
 * nothing. The composition root builds it (`BrowserPlatform`, since P4).
 */
export class LiveKitClientAdapterFactory implements IServiceLiveKitAdapter {
  constructor(private readonly logger: IServiceLogger, private readonly timers: IServiceTimers) {}

  async create(): Promise<IGatewayLiveKit> {
    const { LiveKitClientAdapter } = await import('./LiveKitClientAdapter');
    return new LiveKitClientAdapter(this.logger, this.timers);
  }
}
